import { render, staticRenderFns } from "./BulkMessageTargetCard.vue?vue&type=template&id=d9f31ef6&scoped=true&"
import script from "./BulkMessageTargetCard.vue?vue&type=script&lang=ts&"
export * from "./BulkMessageTargetCard.vue?vue&type=script&lang=ts&"
import style0 from "./BulkMessageTargetCard.vue?vue&type=style&index=0&id=d9f31ef6&lang=scss&scoped=true&"
import style1 from "./BulkMessageTargetCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f31ef6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VIcon})
